const i = () => Date.now().toString(36) + Math.random().toString(36).substring(2), n = {
  created(t) {
    t.setAttribute("id", t.id || i());
  },
  getSSRProps() {
    return {
      id: i()
    };
  }
}, r = {
  install(t) {
    t.directive("uid", n);
  }
};
export {
  n as Uid,
  r as UidPlugin
};
